import apiClient from './axios';

// CS 관리자 전용 로그인.
// 백엔드는 SHA-256 해시된 비밀번호를 기대하므로 호출 측에서 미리 해싱한 값을 전달해야 함.
export async function signIn({ username, email, password }) {
  console.log(`signIn: ${username} / ${password}`);

  const res = await apiClient.post('/v3/auth/signin', {
    username: username,
    // email,
    password: password,
  });

  console.log(`signIn -> ${JSON.stringify(res, null, 2)}`);

  return res.data; // { user, access_token }
}

// 로그아웃 — 백엔드에 알려서 refresh token 쿠키를 정리하게 함.
// 토큰 자체의 localStorage 정리는 호출 측에서 clearAuth()로 별도 처리.
export async function signOut() {
  try {
    const res = await apiClient.post('/v3/auth/signout', {});

    console.log(`signOut -> ${JSON.stringify(res, null, 2)}`);
  } catch (err) {
    // 백엔드가 실패해도 로컬 정리는 진행되어야 하므로 에러는 흡수
    console.warn('signOut failed:', err);
  }
}
